import type { JSX } from 'react'
import type { FIXED_INDENTS } from 'vars/fixed-indents'

import { TextBox, TextBoxTypes } from 'atoms/TextBox'
import { Colors, TextAligning } from 'atoms/TextBox/TextBox.h'
import { PopupHeaderCroppedTemplateSC } from './PopupHeaderCroppedTemplate.styled'

export interface IPopupHeaderCroppedTemplateProps {
  title: string
  font?: TextBoxTypes
  verticalPaddings: FIXED_INDENTS[]
}
export const PopupHeaderCroppedTemplate = ({
  title,
  verticalPaddings,
  font = TextBoxTypes.Headline3,
}: IPopupHeaderCroppedTemplateProps): JSX.Element => (
  <PopupHeaderCroppedTemplateSC verticalPaddings={verticalPaddings}>
    <TextBox
      title={title}
      color={Colors.TEXT_ICON_PRIMARY}
      font={font}
      maxLines={1}
      alignment={TextAligning.Left}
    />
  </PopupHeaderCroppedTemplateSC>
)
